var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarningSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.62 4.487c.347-.65 1.412-.65 1.761 0l7.5 14a.994.994 0 01-.024.988.99.99 0 01-.857.485H4.001a.992.992 0 01-.858-.486.991.991 0 01-.023-.986l7.498-14h.001zm.88.473l-7.499 14h15l-7.5-14zm.5 11v1h-1v-1h1zm0-6v5h-1v-5h1z",
    fill: "#FFB600"
  })));
}

export default "data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M10.6194 4.4875C10.9674 3.8375 12.0324 3.8375 12.3814 4.4875L19.8814 18.4875C20.0484 18.8005 20.0404 19.1695 19.8574 19.4745C19.6754 19.7785 19.3554 19.9605 19.0004 19.9605H4.00138C3.64638 19.9605 3.32538 19.7785 3.14338 19.4745C2.96038 19.1695 2.95238 18.8005 3.12038 18.4875L10.6184 4.4875H10.6194ZM11.5004 4.9605L4.00138 18.9605H19.0004L11.5004 4.9605ZM12.0004 15.9605V16.9605H11.0004V15.9605H12.0004ZM12.0004 9.9605V14.9605H11.0004V9.9605H12.0004Z' fill='%23FFB600' /%3E %3C/svg%3E";
export { SvgWarningSign as ReactComponent };